import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Grid, Typography } from '@mui/material';
import { useStore } from 'src/stores';
import useStyles from './styles';
const AllocationsSummary = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const summary = store.allocations.summary.get(store.allocations.selectedBillingCycleId);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    lg: 4
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.total_bill_amount')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "$", summary === null || summary === void 0 ? void 0 : summary.totalBillAmount))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    lg: 4
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.recovery_enrollment')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "$", summary === null || summary === void 0 ? void 0 : summary.recoveryFullEnrollment))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 4
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.expected_payout_for_enrolled_users')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "$", summary === null || summary === void 0 ? void 0 : summary.expectedEnrolledPayout))));
});
export default AllocationsSummary;